import { TOP_CATEGORIES_DEPTH_LIMIT } from "configs/catalog";
import { call, put, select } from "redux-saga/effects";
import categoriesServiceExt from "_foundationExt/apis/search/categories.service";
import {
  CATEGORYVIEW_TOP_ERROR_ACTION,
  CATEGORYVIEW_TOP_REQUEST_ACTION,
  FETCHING_SELLER_ERROR_ACTION,
  FETCHING_SELLER_SUCCESS_ACTION,
} from "_redux/actions/catalog";
import marketplaceService from "_foundationExt/apis/transaction/marketplace.service";
import { CommerceEnvironment } from "constants/common";
import { getSite } from "_foundation/hooks/useSite";
import {
  localStorageUtil,
  storageSessionHandler,
} from "_foundationExt/utils/storageUtil";
import { constants } from "@hcl-commerce-store-sdk/utils";
import { loginStatusSelector } from "_redux/selectors/user";

export function* loadTopCategories(action: any) {
  try {
    const payload = action.payload;
    const storeId = payload.storeId ? payload.storeId : payload.storeID;

    const parameters = {
      storeId,
      depthAndLimit: TOP_CATEGORIES_DEPTH_LIMIT,
    };
    const response = yield call(categoriesServiceExt.getCategoryViewTop, {
      ...parameters,
    });
    yield put(CATEGORYVIEW_TOP_REQUEST_ACTION(response));
  } catch (error) {
    yield put(CATEGORYVIEW_TOP_ERROR_ACTION(error));
  }
}

export function* fetchSellers(action: any) {
  try {
    const currentUser = storageSessionHandler.getCurrentUserAndLoadAccount();

    if (
      !currentUser?.userLoggedIn &&
      !currentUser?.WCToken &&
      !currentUser?.refreshToken
    ) {
      return;
    }

    const siteInfo = getSite();
    const locale =
      localStorageUtil.get(constants.LOCALE) || CommerceEnvironment.defaultLang;
    const langId = CommerceEnvironment.reverseLanguageMapShort[locale] || "";
    const storeId = siteInfo?.storeID || "";

    const parameters = {
      storeId,
      langId,
    };

    const response = yield call(() =>
      marketplaceService.getMPSellersForStore(parameters)
    );
    yield put(FETCHING_SELLER_SUCCESS_ACTION(response.data));
  } catch (error) {
    yield put(FETCHING_SELLER_ERROR_ACTION(error));
  }
}
